module.exports = __webpack_public_path__ + "img/KSC09172.e3c03329.jpg";